import { createSlice } from '@reduxjs/toolkit'
import { RootState } from '../store/store';

interface TemperatureInstallrequestListState {
    list: any,
  }
  
const initialState:TemperatureInstallrequestListState = {
    list:undefined,
}

export const temperatureInstallRequestListSlice = createSlice({
    name:"temperatureInstallRequestList",
    initialState,
    reducers:{
        UpdateTemperatureInstallRequestList: (state,action) => {
            state.list = action.payload.temperatureInstallRequestList;
        },
        AddTemperatureInstallRequest: (state,action) => {
            state.list = undefined;
        },
        EditTemperatureInstallRequest: (state,action) => {
            state.list = undefined;
        },
        RemoveTemperatureInstallRequest: (state,action) => {
            state.list = undefined;
        }
    }
})

export const {UpdateTemperatureInstallRequestList,AddTemperatureInstallRequest,EditTemperatureInstallRequest,RemoveTemperatureInstallRequest} = temperatureInstallRequestListSlice.actions

export const selecttemperatureInstallRequestList = (state: RootState) => state.temperatureInstallRequestList

export default temperatureInstallRequestListSlice.reducer;